import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Card, Form } from 'react-bootstrap';
import { isJsonValueEmpty, isInt, isValueEmpty, isJsonString, toStringOrEmpty } from '@awp/helpers/utilsReact';
import { FROST_PROBE_CONFIG, SNOW_POLE_CONFIG } from '@awp/constants';
import {
  isEditing,
  setEditing,
  setPlacement,
  setOrignPlacement,
  savePlacement,
  getSelectedPlacement,
  getSaveError,
} from '@stores/sensorEquipmentPacketSlice';

const txtFontSize = {
  fontSize: '90%',
};
const lablStyle = {
  marginBottom: '0rem',
};
//a blank small column
const blankColumn = {
  maxWidth: '2rem',
};

const geoLabel = {
  display: 'flex',
  alignItems: 'stretch',
  fontSize: '90%',
};

const SensorPlacementEdit = ({ placement }) => {
  const dispatch = useDispatch();
  const selectedPlacement = useSelector(getSelectedPlacement);
  const saveError = useSelector(getSaveError);

  const updateLongitude = (e) => {
    e.preventDefault();

    let _selectedPlacement = { ...selectedPlacement };
    _selectedPlacement.Longitude = e.target.value;
    dispatch(setPlacement(_selectedPlacement));
  };
  const updateLatitude = (e) => {
    e.preventDefault();

    let _selectedPlacement = { ...selectedPlacement };
    _selectedPlacement.Latitude = e.target.value;
    dispatch(setPlacement(_selectedPlacement));
  };

  const getError = (field) => {
    if (isJsonValueEmpty(saveError)) return '';
    let err = { ...saveError };
    field = (field + '').toLocaleLowerCase();
    for (let key in err.errors) {
      let k = key.toLocaleLowerCase();
      if (k == field) {
        return err.errors[key];
      }
    }
    return '';
  };

  return (
    selectedPlacement && (
      <>
        <Col md={1} style={blankColumn} />
        <Col md={4}>
          <Form.Group>
            <Form.Label style={lablStyle}>
              <b>Coordinates</b>
            </Form.Label>
            <br />
            <Row>
              <Col md={6} style={geoLabel}>
                <div style={{ marginRight: '0.4rem' }}>{'Lat:'}</div>
                <Form.Group>
                  <Form.Control
                    onChange={updateLatitude}
                    className="text-size90"
                    type="text"
                    value={isValueEmpty(selectedPlacement.Latitude) ? '' : selectedPlacement.Latitude}
                    //className={getSensorOservationTypeStyleState("dno"+sensorObservationType.Id)}
                  />
                  {!isValueEmpty(getError('Latitude')) && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                      {getError('Latitude')}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} style={geoLabel}>
                <div style={{ marginRight: '0.4rem' }}>{'Long:'}</div>
                <Form.Group>
                  <Form.Control
                    onChange={updateLongitude}
                    className="text-size90"
                    type="text"
                    value={isValueEmpty(selectedPlacement.Longitude) ? '' : selectedPlacement.Longitude}
                    //className={getSensorOservationTypeStyleState("dno"+sensorObservationType.Id)}
                  />
                  {!isValueEmpty(getError('Longitude')) && (
                    <Form.Control.Feedback type="invalid" className="d-block">
                      {getError('Longitude')}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label style={lablStyle}>
              <b>Sensor Type</b>
            </Form.Label>
            <br />
            <div style={txtFontSize}>{selectedPlacement.SensorTypeName}</div>
          </Form.Group>
        </Col>
      </>
    )
  );
};

SensorPlacementEdit.propTypes = {
  placement: PropTypes.any.isRequired,
};

export default SensorPlacementEdit;
